module.exports = __webpack_public_path__ + "static/media/LandingGroup2.4aa8492b.gif";